export default __webpack_public_path__ + "static/media/icon-padded.f718afb7.svg";